export const MINUTES_IN_DAY = 24 * 60;

export const workingIntervals = (
  opening,
  closing,
  lunchStart = null,
  lunchEnd = null
) => {
  if (lunchStart === null) return [[opening, closing]];

  return [
    [opening, Math.min(closing, lunchStart)],
    [Math.max(opening, lunchEnd), closing],
  ].filter(([start, end]) => start < end);
};

export const formatMinuteOfDay = minute =>
  `${String(Math.floor(minute / 60)).padStart(2, '0')}:${String(
    minute % 60
  ).padStart(2, '0')}`;
